import Vue from 'vue'
import Vuex from 'vuex'
import {Server} from "@/common/server/server";
import ReactivePromiseStatus from "reactive-promise-status/dist/reactive-promise-status";
import {Translator} from "@/common/translator";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isAuthorized: false,
        token: localStorage.token ?? null,
        commonData: new ReactivePromiseStatus(null, false),
        contextMenu: null,
        notifications: [],
        reloadData: new Date().getTime()
    },
    mutations: {
        setToken(state, token) {
            console.log('setToken', token)
            localStorage.token = token;
            document.cookie = 'download_token_2=' + token + ';path=frontendApi/Disk/Download;max-age=' + (3600 * 24 * 7)
            state.token = token;
        },
        setIsAuthorized(state, isAuthorized) {
            state.isAuthorized = isAuthorized;
        },
        setCommonDataPromise(state, {promise, keepOld}) {
            console.log('zzzzz')
            state.commonData.keepOld = keepOld;
            state.commonData.promise = promise;
        },
        setContextMenu(state, data) {
            state.contextMenu = data;
        },
        showNotification(state, data) {
            console.log('showNotification', data)
            this._vm.$set(data, 'symbol', Symbol());
            state.notifications.push(data);

            setTimeout(() => state.notifications = state.notifications.filter(x => x !== data), 5000);
        },
        closeNotification(state, data) {
            state.notifications = state.notifications.filter(x => x !== data)
        },
        setReloadData(state) {
            state.reloadData = new Date().getTime()
        }
    },
    actions: {
        async loadCommonData(store) {
            console.log('loadCommonData')
            const promise = Server.Common.LoadCommonData();
            store.commit('setCommonDataPromise', {promise, keepOld: false});
            store.dispatch('parseCommonData', await promise)
            store.dispatch('prepareRefreshingOfToken', await promise)
        },
        async refreshCommonData(store) {
            console.log('refreshCommonData')
            const promise = Server.Common.LoadCommonData();
            await promise
            store.commit('setCommonDataPromise', {promise, keepOld: true});
            store.dispatch('parseCommonData', await promise)
        },
        parseCommonData(store, data) {
            if (data.user) {
                store.commit('setIsAuthorized', true);
                Translator.changeLanguage(data.user.interfaceLanguage);
            } else {
                store.commit('setIsAuthorized', false);
            }
        },
        prepareRefreshingOfToken(store, data) {
            if (data.user) {
                const minimumTimeToExpiration = 72 * 3600 * 1000;//72h
                const optimalTimeToExpiration = 6 * 24 * 3600 * 1000;//6days
                if (data.user.milisecondsToExpire < minimumTimeToExpiration) {
                    store.dispatch('refreshToken');
                } else if (data.user.milisecondsToExpire < optimalTimeToExpiration) {
                    setTimeout(() => store.dispatch('refreshToken'), 10000)
                } else {
                    setTimeout(() => store.dispatch('refreshToken'), data.user.milisecondsToExpire - optimalTimeToExpiration)
                }
            }
        },
        async refreshToken(store) {
            const token = await Server.Authorization.RefreshToken();
            store.commit('setToken', token)
        },
        refreshFromLocalStorage(store) {
            console.log('refreshFromLocalStorage')
            if (store.state.token && localStorage.token && store.state.token != localStorage.token) {
                store.commit('setToken', localStorage.token)
                store.dispatch('loadCommonData');
            }
        },
        logout() {
            store.commit('setToken', '')
            store.commit('setIsAuthorized', false);
        }
    },
    modules: {},
    getters: {
        role(state) {
            return state.commonData.data?.user?.role;
        },
        hideInTimechecker(state) {
            return state.commonData.data?.user?.hideInTimechecker;
        },
        leaveEnabled(state) {
            return state.commonData.data?.user?.leaveEnabled;
        },
        responsibleLocationsID(state) {
            return state.commonData.data?.user?.responsibleLocationsID;
        },
        usersLocationID(state) {
            return state.commonData.data?.user?.locationID;
        },
        userID(state) {
            return state.commonData.data?.user?.id;
        },
        interfaceLanguage(state) {
            return state.commonData.data?.user?.interfaceLanguage;
        },
        isAdmin(state) {
            return state.commonData.data?.user?.role === 'Administrator'
        },
        isManager(state) {
            return state.commonData.data?.user?.role === 'Manager'
        },
        isWorker(state) {
            return state.commonData.data?.user?.role === 'Worker'
        },
        showAdditionalTimechekers(state) {
            return !!state.commonData.data?.showAdditionalTimechekers
        },
        getReloadData(state) {
            return state.reloadData
        },
        timecheckerAllowedLocations(state) {
            return state.commonData.data?.timecheckerAllowedLocations
        },
        canGlobal(state) {
            return (permission) => {
                return state.commonData.data?.user?.permissions.some(x => x.permission == permission && x.global)
            }
        },

        canAnything(state) {
            return (permission) => {
                return state.commonData.data?.user?.permissions.some(x => x.permission == permission)
            }
        },
        canInLocation(state) {
            return (permission, locationId) => {
                return state.commonData.data?.user?.permissions.some(x => x.permission == permission && ((x.locationID == locationId && locationId != null) || x.global))
            }
        },
        canForUser(state) {
            return (permission, subjectUserLocationId, subjectUserId) => {
                console.log('canForUser', permission, subjectUserLocationId, subjectUserId)
                return state.commonData.data?.user?.permissions.some(x => x.permission == permission && (x.subjectUserID == subjectUserId ||
                    (x.locationID == subjectUserLocationId &&
                        subjectUserLocationId != null) || x.global))
            }
        }
    }
})
export default store;

setInterval(() => store.dispatch('refreshFromLocalStorage'), 600000);
addEventListener('focus', () => store.dispatch('refreshFromLocalStorage'));
